module.exports = __webpack_public_path__ + "static/media/yobm.7212988d.png";